import { HttpTypes } from '@/types';
import { IUploadFileImage, UnsplashPhoto } from '@/types/general';
import { IAsset } from '@/types/site';
import { AxiosInstance } from 'axios';

class FileService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<IAsset[]>> {
    const result = await this.client.get('/sites/files/manager/list', { params: queryParams });
    return result.data;
  }

  async uploadImage(data: FormData): Promise<HttpTypes.IResponse<IUploadFileImage>> {
    const result = await this.client.post('/sites/upload/image', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return result.data;
  }

  async unsplashImage(
    queryParams: HttpTypes.FindParams
  ): Promise<HttpTypes.IResponse<UnsplashPhoto[]>> {
    const result = await this.client.get('/sites/unsplash/search', { params: queryParams });
    return result.data;
  }
}

export default FileService;
